import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Aside from '../../components/Aside/Aside';
import Footer from '../../components/Footer/Footer';
import {apiRequest, apiRequestAnonymous} from "../../utils/request";
import userManager, { configureUserManager } from "../../utils/userManager";

class LandingPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.fetchConfig = this.fetchConfig.bind(this);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.state = {
      siteConfig: {
        companyName: "Sydney Recycling Services",
        styleName: "srs-prod",
      }
    };
  }

  fetchConfig(){
    apiRequestAnonymous(`/api/config`)
        .then(x => {
          // This page fetches config for itself rather than going through loadApiConfig, so it has
          // to do the same late-binding - otherwise its own "here to login" link throws on a browser
          // that has never loaded the app, which is most visitors to a landing page.
          configureUserManager(x.data);
          this.setState({siteConfig: {...x.data}});
        });
  }

  componentDidMount() {
    this.fetchConfig();
  }
  
  redirectToLogin(e){
    e.preventDefault();
    userManager.signinRedirect();
  }
  
  render() {
    return (
      <div className="app">
        <Header account={this.props.account} siteConfig={this.state.siteConfig} />
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main" style={{minHeight:'1024px', overflowX: 'auto'}}>
            <div className="container">
              <div className={'row mt-5'}>
                <div className={'col-12'}>&nbsp;
                </div>
              </div>
              <div className={'row mt-5'}>
              <div className={'col-12'}>&nbsp;
              </div>
              </div>
              <div className={'row mt-5'}>
                <div className={'col-12'}>
                  <p>If you are already a user, click <a href={""} onClick={this.redirectToLogin}>here to login</a></p>
                  <p>To become a new user, please follow this <a href={""} onClick={this.redirectToLogin}>link</a> to go to our login screen, by joining with a Facebook or Google account you will then be able to continue the registration process</p>
                </div>
              </div>
            </div>
          </main>
          <Aside driverRuns={this.props.driverRuns} />
        </div>
        <Footer siteConfig={this.state.siteConfig} />
      </div>
    );
  }
}

LandingPage.propTypes = {
  dispatch: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(null, mapDispatchToProps)(LandingPage);
